import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { landingPageService, type ChallengesSection } from "../services/landingPageService";

interface LandingChallengesState {
  data: ChallengesSection | null;
  loading: boolean;
  error: string | null;
}

const initialState: LandingChallengesState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchLandingChallenges = createAsyncThunk(
  "landingChallenges/fetch",
  async (_, { rejectWithValue }) => {
    try {
      return await landingPageService.getChallenges();
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch challenges section"
      );
    }
  }
);

const landingChallengesSlice = createSlice({
  name: "landingChallenges",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingChallenges.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingChallenges.fulfilled, (state, action: PayloadAction<ChallengesSection>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLandingChallenges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default landingChallengesSlice.reducer;